require('./modules/fosRouting.js');
require('./modules/payments.js');
require('./modules/guaranteed-payments.js');
require('./contract-main.js');
require('./public-schedule-main.js');
require('./payment-settings-main.js');
require('./new-dashboard-main.js');
require('./client-settings-main.js');
// require('./parentDashboard/main.js');
require('./sca-one-off-payments-main.js');
require('./global-main.js');
require('./public-banner-main.js')
